import React, { PureComponent, type Node } from 'react';
import cx from 'classnames';
import 'client/styles/card.scss';

type HighlightColorTypes = 'green' | 'red' | 'orange' | 'grey';

type Props = {
  style: Object,
  className: string,
  children: Node,
  shadow: boolean,
  highlight: HighlightColorTypes,
  border: boolean,
};

export default class Card extends PureComponent<Props> {
  static defaultProps = {
    style: {},
    className: null,
    children: null,
    shadow: true,
    highlight: null,
    border: false,
  };

  render() {
    const { style, className, highlight, shadow, border } = this.props;
    return (
      <div
        className={cx('card', className, { [`highlight ${highlight}`]: highlight, shadow, border })}
        style={style}>
        {this.props.children}
      </div>
    );
  }
}
